export default __webpack_public_path__ + "static/media/P400_CoC.8a83568b.pdf";